import { CompanyGroupPortalRoleModel, CurrentUser, CustomerPortalRoleModel } from "../redux/types";

export const hasAnyRequiredCustomerPolicy = (user: CurrentUser | null, currentCustomerId: string | null, ...requiredPolicies: (keyof CustomerPortalRoleModel)[]) => {
    if (!user || !currentCustomerId) {
        return false
    }

    if (requiredPolicies.length === 0) {
        return true
    }

    const customerPortalUser = user.customers.find(x => x.customerId === currentCustomerId)
    if (!customerPortalUser) {
        return false
    }

    if (customerPortalUser.isOwner) {
        return true
    }

    return requiredPolicies.some(policy =>
      customerPortalUser.portalRoles.some(role => role[policy])
    );
}

export const hasAnyRequiredCompanyGroupPolicy = (user: CurrentUser | null, currentCompanyGroupId: string | null, ...requiredPolicies: (keyof CompanyGroupPortalRoleModel)[]) => {
    if (!user || !currentCompanyGroupId) {
        return false
    }

    if (requiredPolicies.length === 0) {
        return true
    }

    const companyGroupPortalUser = user.companyGroups.find(x => x.id === currentCompanyGroupId)
    if (!companyGroupPortalUser) {
        return false
    }

    if (companyGroupPortalUser.isOwner) {
        return true
    }

    return requiredPolicies.some(policy =>
      companyGroupPortalUser.portalRoles.some(role => role[policy])
    );
}

export const userHasAuthorization = (user: CurrentUser, currentCustomerId: string, authorizationPredicate: (role: CustomerPortalRoleModel) => boolean) => {
    const customerPortalUser = user.customers.find(x => x.customerId === currentCustomerId)
    if (!customerPortalUser) {
        return false
    }

    if (customerPortalUser.isOwner) {
        return true
    }

    return customerPortalUser.portalRoles.some(authorizationPredicate)
}
